import * as url from "./url"
export function getUserAgent() {
  let ua = {},
    agent = navigator.userAgent,
    m
  ua.iPod = agent.indexOf("iPod") > -1
  ua.iPad = agent.indexOf("iPad") > -1
  ua.iPhone = agent.indexOf("iPhone") > -1
  agent.indexOf("Android") > -1 && (ua.android = parseFloat(agent.slice(agent.indexOf("Android") + 8)))

  if (ua.iPad || ua.iPhone || ua.iPod) {
    ua.iOS = true
  }

  ua.wp = agent.indexOf("Windows Phone") > -1

  // 微信UA
  m = / MicroMessenger\/([0-9\.]+)/i.exec(agent)
  m && (ua.weixin = parseFloat(m[1], 10))

  // 微信小程序
  ua.weixinminiprogram =
    (agent.match(/micromessenger/i) && agent.match(/miniprogram/i)) ||
    window.__wxjs_environment === "miniprogram" ||
    url.getParam("fromMini") == 1

  // 手QUA
  m = / QQ\/([0-9\.]+)/i.exec(agent)
  m && (ua.QQ = m[1])

  //手空
  ua.qzone = agent.indexOf("Qzone/") > -1

  //MSDK浏览器

  ua.msdk = agent.indexOf("MSDK/") > -1

  return ua
}
